import { useEffect, useState } from "react";
import Error from "./common/Error";
import { fetchWithRetry, isEmpty } from "../Util";
import { useSearchParams } from "react-router-dom";
import Result from "./common/Result";
import Layout from "./common/Layout";
import Loader from "./common/Loader";
import { useTranslation } from "react-i18next";
import { handleException } from "../store/Actions";
import { useSelector } from "react-redux";
import Back from "./common/Back";

const BankingTransferCallback = () => {

  let [status, setStatus] = useState(undefined);
  let [params] = useSearchParams();

  const isWhiteLabel = useSelector((state) => state.Reducer.settings?.isWhiteLabel)
  const error = useSelector((state) => state.Reducer.error)

  const { t } = useTranslation()

  useEffect(() =>  {
    fetchWithRetry('/verification/bankverification/callback',  
      (status) => setStatus(status), 
      () => handleException(), 500, 500)
  }, [params])

  return (    
    <Layout>
        <div className="az-pay-title">
          {t("bankingTransferCallback.title")}
        </div>
        <Loader loading={isEmpty(status)} message={t('bankingTransferCallback.loading.text')} />
        <Error message={t('bankingTransferCallback.error.text')} />
        <Back renderer={!isEmpty(error)} message={t('app.back.link')} />
        <Result status={status} 
          successMessage={t('bankingTransferCallback.success.text') + ' ' + t('bankingTransferCallback.success.back.text')} 
          failureMessage={t('bankingTransferCallback.failure.text')}
          mailTo={!isWhiteLabel} />
    </Layout>
  );
}

export default BankingTransferCallback;